/**
 * [ File :: B_TryCount.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/attr/B_TryCount.js
 * @목적 : 게임 Qustion 단위 게임 카운드 관련 객체
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

const B_TryCount = (function(){

    // [V]
    const $ = {
		__entry : null,
	    __clear : null,
	    __fail  : null,
	    __repeatClear : null,
	    __repeatFail : null,
    };

	class B_TryCount {

		constructor() {
			$.__entry = 0;
			$.__clear = 0;
			$.__fail = 0;
			$.__repeatClear = 0;
			$.__repeatFail = 0;
		}

		// [V]

		// @DES(public) :: count 관련 변수
		get entry() {return $.__entry; }
		get clear() {return $.__clear; }
		get fail() {return $.__fail; }
		get repeatClear() {return $.__repeatClear; }
		get repeatFail() {return $.__repeatFail; }

		// [F]

		/**
		 * @DES ::
		 * @IP1 :: result {boll} - 성공/실패여부
		 * @S.E ::
		 */
		count(result) {
			if(typeof result == 'boolean') {
				if(result == false) {
					$.__entry += 1;
					$.__fail += 1;
					$.__repeatClear = 0;
					$.__repeatFail  += 1;
				}
				if(result == true) {
					$.__entry += 1;
					$.__clear += 1;
					$.__repeatClear += 1;
					$.__repeatFail  = 0;
				}
			}
		}
	}

	return B_TryCount;
}());

export default B_TryCount;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/attr/B_TryCount.js